<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 136.91 20.76"
        :aria-label="`Waardering: ${rating} uit 5 sterren`"
        role="img"
        class="star-rating"
    >
        <defs>
            <title>Waardering: {{ rating }} uit 5 sterren</title>
            <desc>
                Waardering: {{ rating }} uit 5 sterren
            </desc>
        </defs>

        <circle :class="rating >= 1 ? 'cls-1' : 'cls-2'" cx="10.38" cy="10.38" r="10.38" />
        <template v-if="rating === 0.5">
            <circle class="cls-1" cx="10.38" cy="10.38" r="10.38" />
            <path class="cls-2" d="m10.38,0c5.73,0,10.38,4.65,10.38,10.38s-4.65,10.38-10.38,10.38" />
        </template>

        <circle :class="rating >= 2 ? 'cls-1' : 'cls-2'" cx="39.42" cy="10.38" r="10.38" />
        <template v-if="rating === 1.5">
            <path class="cls-1" d="m39.42,0c5.73,0,10.38,4.65,10.38,10.38s-4.65,10.38-10.38,10.38" />
            <circle class="cls-2" cx="39.42" cy="10.38" r="10.38" />
        </template>

        <circle :class="rating >= 3 ? 'cls-1' : 'cls-2'" cx="68.45" cy="10.38" r="10.38" />
        <template v-if="rating === 2.5">
            <circle class="cls-1" cx="68.45" cy="10.38" r="10.38" />
            <path class="cls-2" d="m68.45,0c5.73,0,10.38,4.65,10.38,10.38s-4.65,10.38-10.38,10.38" />
        </template>

        <circle :class="rating >= 4 ? 'cls-1' : 'cls-2'" cx="97.49" cy="10.38" r="10.38" />
        <template v-if="rating === 3.5">
            <circle class="cls-1" cx="97.49" cy="10.38" r="10.38" />
            <path class="cls-2" d="m97.49,0c5.73,0,10.38,4.65,10.38,10.38s-4.65,10.38-10.38,10.38" />
        </template>

        <circle :class="rating >= 5 ? 'cls-1' : 'cls-2'" cx="126.53" cy="10.38" r="10.38" />
        <template v-if="rating === 4.5">
            <circle class="cls-1" cx="126.53" cy="10.38" r="10.38" />
            <path class="cls-2" d="m126.53,0c5.73,0,10.38,4.65,10.38,10.38s-4.65,10.38-10.38,10.38" />
        </template>
    </svg>
</template>

<script setup>
defineProps({
    rating: {
        type: Number,
        required: true,
    },
});
</script>

<style scoped>
.star-rating {
    width: 100%;
    height: auto;
    max-width: 80px;
}
.cls-1 {
    fill: #0b59a0;
}
.cls-1,
.cls-2 {
    stroke-width: 0px;
}
.cls-2 {
    fill: #ddd;
}
</style>
